export default function About() {
    return <h2>Review plan</h2>;
}